var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medal-component"},[_c('div',{staticClass:"medal-img",class:[
         ("size-" + _vm.size),
         ("status-" + _vm.status)
       ],on:{"click":_vm.handleClick}},[_c('ym-img',{staticClass:"img",attrs:{"src":_vm.medal,"alt":_vm.title,"lazy":_vm.lazy}})],1),_c('medal-popup',{attrs:{"show":_vm.showPopup,"title":_vm.title,"src":_vm.medal,"desc":_vm.desc},on:{"update:show":function($event){_vm.showPopup=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }